module.exports = __webpack_public_path__ + "7b822e89a441c8f4bf5ecc68cff15c96.png";